import MobileField from './mobile-field.vue';

export default MobileField;
